import { render, staticRenderFns } from "./GruposTab.vue?vue&type=template&id=6e207f6e"
import script from "./GruposTab.vue?vue&type=script&lang=js"
export * from "./GruposTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports